<style src="./Nav.scss" lang="scss"></style>

<template lang="pug">
  nav.nav
    ul.nav__list
      li.nav__item(
        v-for="link in links"
        :key='link.name'
      )
        router-link.nav__link(
          :to="link.path"
          :class="isActive(link.name)"
        )
          .nav__icon
            Icon(
              :name='link.icon'
            )
          span.nav__label {{ link.meta.title }}
</template>
<script>
import Icon from "@/components/Icon/Icon";

export default {
  components: {
    Icon
  },
  computed: {
    routes() {
      return this.$router.options.routes;
    },
    links() {
      return [
        this.routes.find(route => route.name === "tracks"),
        this.routes.find(route => route.name === "albums"),
        this.routes.find(route => route.name === "artists"),
        this.routes.find(route => route.name === "charts")
        // this.routes.find(route => route.name === "books")
      ];
    }
  },
  methods: {
    isActive(name) {
      return this.$route.name === name && "is-active";
    }
  }
};
</script>
